var __jsx = React.createElement;
import React from "react";
import classNames from "classnames";
import { faChevronDown, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
import { useTranslation } from "react-i18next";
import FormSubSection from "./FormSubSection";
var FormSection = function FormSection(_ref) {
  var group = _ref.group,
    isExpanded = _ref.isExpanded,
    filled = _ref.filled,
    total = _ref.total,
    onToggle = _ref.onToggle;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4 bg-[#F3F4F5] dark:bg-[#0C1723] rounded-xl border border-[#DEE1E2] dark:border-[#38414B]"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return onToggle(group.id);
    },
    className: classNames("w-full px-6 py-4 flex items-center justify-between bg-[#E8E9EA] dark:bg-[#141f2a] transition-colors", {
      "rounded-xl": !isExpanded,
      "rounded-t-xl": isExpanded
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isExpanded ? faChevronDown : faChevronRight,
    className: "w-4 h-4 text-[#0C1723] dark:text-[#F6F7F7]"
  }), /*#__PURE__*/React.createElement("span", {
    className: "text-base font-medium text-[#0C1723] dark:text-[#F6F7F7] tracking-wide"
  }, group.heading)), total > 0 && /*#__PURE__*/React.createElement("div", {
    className: classNames("text-sm font-semibold rounded-xl px-3 tracking-wider", {
      "bg-[#9AE6C4] dark:bg-[#005C34] text-[#007A43] dark:text-[#5DDAA2]": filled === total,
      "bg-[#F9EBCA] dark:bg-[#422A10] text-[#B17900] dark:text-[#FCD26C]": filled !== total
    })
  }, filled, " / ", total, " ", t("required_key").toUpperCase())), isExpanded && /*#__PURE__*/React.createElement("div", {
    className: "px-5 pb-4 border-t border-gray-200 dark:border-gray-700"
  }, group.visibleSubSections.map(function (subSection) {
    return /*#__PURE__*/React.createElement(FormSubSection, {
      key: subSection.id,
      subSection: subSection
    });
  })));
};
export default FormSection;